module.exports = __webpack_public_path__ + "img/HZGB03-02.2e83fe9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/HZGB03-02.png
// module id = fLmX
// module chunks = 0